// Import components
import CreateButton from "global/components/CreateButton";



const Pagination = ({
    currentPage,
    setCurrentPage,
    totalPages,
    rowsPerPage,
    setRowsPerPage,
    rowsPerPageOptions = [10, 50, 100, 500],
    setSelectedRows,
    paginationDropdownMessage,
    onPageChangeScroll,
}) => {



    // Handle changing page.
    const handlePageChange = (pageBuilder) => {

        // Clear any selected rows.
        setSelectedRows([]);

        // Update the page.
        setCurrentPage((previousPage) => {

            // Calculate the next page.
            const nextPage = pageBuilder(previousPage);

            // Only scroll if the page actually changed.
            if (
                nextPage !== previousPage &&
                typeof onPageChangeScroll === "function"
            ) {

                // Scroll back to the top of the table.
                onPageChangeScroll();

            }

            // Return the next page.
            return nextPage;

        });

    };



    return (

        <div style={{ marginTop: "10px", overflow: "auto", display: "flex" }}>

            <CreateButton
                title="<"
                size="s"
                onClick={() =>
                    handlePageChange((previousPage) =>
                        Math.max(previousPage - 1, 1)
                    )
                }
                disabled={currentPage === 1}
            />

            <span style={{ margin: "0 10px", alignContent: "center", minWidth: "30px" }}>

                {/* Check if the total number of pages is 0 - if so set the current page number to 0 */}
                Page {totalPages === 0 ? "0" : currentPage} of {totalPages}

            </span>

            <CreateButton
                title=">"
                size="s"
                onClick={() =>
                    handlePageChange((previousPage) =>
                        Math.min(previousPage + 1, totalPages)
                    )
                }
                disabled={currentPage === totalPages || totalPages === 0}
            />

            <select value={rowsPerPage}
                style={{ width: "auto", marginLeft: "10px" }}
                onChange={(e) => {

                    // Reset back to the first page.
                    setCurrentPage(1);

                    // Clear selected rows.
                    setSelectedRows([]);

                    // Update the number of rows.
                    setRowsPerPage(Number(e.target.value));

                    // Scroll back to the table.
                    if (typeof onPageChangeScroll === "function") {

                        onPageChangeScroll();

                    }

                }}
            >

                {rowsPerPageOptions.map((value) => (

                    <option key={value} value={value}>{value} {paginationDropdownMessage}</option>

                ))}

            </select>

        </div>

    );
};

export default Pagination;
